import { Box, Flex } from "@mantine/core";
import { MRT_DensityState, MRT_Row, MRT_RowData, } from 'mantine-react-table-open';
import React, { useEffect, useState } from "react";
import NoDataFound, { TableNoDataFound } from "../NoDataFound";
import { clickableColor } from "./sizes";
import type { MRT_TableOptions } from 'mantine-react-table-open';


export const loadertype = 'bars';
export const mantineSearchTextInputVariant = 'default'
export const useMantineReactUseTable = <Tdata extends MRT_RowData>(data: Tdata[], ComponentName: string, isActions?: boolean, isExpandable?: boolean) => {
    const [isData, setIsData] = useState<boolean>(false);

    useEffect(() => {
        setIsData(data && data?.length > 0);
    }, [data]);

    return {
        enableBottomToolbar: isData,
        // enableFilters: isData,
        // enableColumnFilters: isData,
        enableDensityToggle: isData,
        enableFullScreenToggle: isData,
        enableRowActions: isActions && isData,
        enableColumnResizing: true,
        enableColumnVirtualization: true,
        // enableGlobalFilterModes: true,
        enableExpandAll: isExpandable ? true : false,
        enableExpanding: isExpandable ? true : false,
        enablePagination: true,
        enablePinning: true,
        enableRowNumbers: false,
        enableRowVirtualization: true,
        manualPagination: ComponentName === 'Users' || ComponentName === 'Roles' ? false : true,
        enableColumnPinning: true,
        // manualFiltering: true,
        isMultiSortEvent: () => true,
        mantineLoadingOverlayProps: {
            loaderProps: {
                color: clickableColor,
                type: loadertype,
                size: 'md',
            },
        },

        mantineSearchTextInputProps: {
            variant: mantineSearchTextInputVariant,
        },

        initialState: {
            columnPinning: {
                right: ["mrt-row-actions"],
            },
            density: "xs" as MRT_DensityState,
            showGlobalFilter: true,
        },
        mantinePaperProps: {
            shadow: "none",
        },
        displayColumnDefOptions: {
            'mrt-row-expand': {
                Header: '',
                size: 50,
            },
        },
        renderEmptyRowsFallback: () => (
            <TableNoDataFound
                title={ComponentName}
                iconName={
                    ComponentName === 'Inovice Time Approvals'
                        ? 'Receipt'
                        : 'CircleOff'
                }
            />
        ),
    }
}

export const useMantineReactDocumentTable = () => {
    return {
        mantineLoadingOverlayProps: {
            loaderProps: {
                color: clickableColor,
                type: loadertype,
                size: 'md',
            },
        },
    }
}



export const useMantineTableStyles = <T extends MRT_RowData,>(isActions = false, setHoveredRowId?: React.Dispatch<React.SetStateAction<string | null>>): Partial<MRT_TableOptions<T>> => ({
    enableColumnResizing: true,
    enableTopToolbar: isActions,
    enableRowActions: true,
    enableColumnPinning: true,
    positionActionsColumn: 'last',
    ...useMantineReactDocumentTable(),
    mantineTableBodyCellProps: {
        style: {
            whiteSpace: 'normal' as const,
            wordBreak: 'break-word' as const,
            lineHeight: 1.4,
            padding: '12px',
        },
    },

    mantineTableHeadCellProps: {
        style: {
            textTransform: 'uppercase' as const,
            fontWeight: 600,
            fontSize: '12px',
            color: 'light-dark(#5a6067, #C1C2C5)',
            height: '65px',
        },
    },

    mantineTableHeadRowProps: {
        style: {
            backgroundColor: 'light-dark(#f1f3f5, #25262b)',
        },
    },

    mantineTableContainerProps: {
        style: {
            backgroundColor: 'transparent',
        },
    },

    mantineTableBodyRowProps: ({ row }) => ({
        style: {
            minHeight: '60px',
            backgroundColor: 'light-dark(#ffffff, #2c2e33)',
            borderRadius: '19px',
            border: 'light-dark(1px solid #e9ecef, 1px solid #373A40)',
            marginTop: '7px',
            marginBottom: '7px',
            fontWeight: 'bold',
            transition: 'transform 0.25s ease, box-shadow 0.25s ease',
            overflow: 'hidden',
            width: '100%',
        },

        sx: {
            '& td:first-of-type': {
                borderTopLeftRadius: '19px',
                borderBottomLeftRadius: '19px',
            },
            '& td:last-of-type': {
                borderTopRightRadius: '19px',
                borderBottomRightRadius: '19px',
            },
            '&.Mui-selected, &.Mui-selected:hover': {
                borderRadius: '19px !important',
            },
        },

        onMouseEnter: (e) => {
            e.currentTarget.style.transform = 'scale(0.99)';
            e.currentTarget.style.borderRadius = '19px';
            setHoveredRowId?.(row.id);   // ✅ KEY FIX
        },

        onMouseLeave: (e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.borderRadius = '19px';
            setHoveredRowId?.(null);     // ✅ RESET
        },
    }),


    /* HEADER CELLS */
    // mantineTableHeadCellProps: {
    //   style: {
    //     backgroundColor: '#f1f3f5',
    //     textTransform: 'uppercase',
    //     fontWeight: 600,
    //     fontSize: '12px',
    //     color: '#495057',
    //     height: '45px',
    //     borderBottom: '1px solid #dee2e6',
    //   },
    // },




    /* BODY CELLS */
    // mantineTableBodyCellProps: {
    //   style: {
    //     paddingTop: '12px',
    //     paddingBottom: '12px',
    //     backgroundColor: 'transparent',
    //   },
    // },

    /* PINNED BODY CELLS FIX */
    // mantineTableBodyCellProps: ({ cell }) => ({
    //   style: {
    //     backgroundColor: cell.column.getIsPinned() ? '#ffffff' : 'transparent',
    //   },
    // }),


    // mantineTableHeadCellProps: ({ column }) => ({
    //   style: {
    //     backgroundColor: '#f1f3f5',
    //     textTransform: 'uppercase',
    //     fontWeight: 600,
    //     fontSize: '12px',
    //     height: '45px',
    //     zIndex: column.getIsPinned() ? 3 : 1,
    //   },
    // }),



    // Header cells (normal + pinned)
    // mantineTableHeadCellProps: ({ column }) => ({
    //   style: {
    //     backgroundColor: '#f1f3f5',     // uniform light-gray
    //     textTransform: 'uppercase',
    //     fontWeight: 600,
    //     fontSize: '12px',
    //     color: '#495057',
    //     height: '45px',                  // same height for all headers
    //     borderBottom: '1px solid #dee2e6', // optional separation
    //     zIndex: column.getIsPinned() ? 3 : 1, // pinned headers on top
    //   },
    // }),

    // mantineTableHeadCellProps: ({ column }) => ({
    //   style: {
    //     backgroundColor: '#f1f3f5',     // force light-gray
    //     textTransform: 'uppercase',
    //     fontWeight: 600,
    //     fontSize: '12px',
    //     color: '#495057',
    //     height: '45px',                  // uniform header height
    //     borderBottom: '1px solid #dee2e6',
    //     zIndex: column.getIsPinned() ? 3 : 1,
    //     // FORCE background so resizing doesn’t change it
    //     background: '#f1f3f5 !important',
    //   },
    // }),
    // initialState: {
    //   columnPinning: {
    //     right: ["mrt-row-actions"],
    //   },
    //   density: "xs" as MRT_DensityState,
    // },
    // mantineTableBodyCellProps: {
    //   style: {
    //     whiteSpace: 'normal',      // allow wrapping
    //     wordBreak: 'break-word',   // break long words
    //     lineHeight: 1.4,
    //     paddingTop: '12px',
    //     paddingBottom: '12px',
    //   },
    // },


});


export const useMantineReactTableDocuments = <Tdata extends MRT_RowData>(data: Tdata[], ComponentName: string, isActions: boolean, dataType?: '') => {
    const [isData, setIsData] = useState<boolean>(false);

    useEffect(() => {
        setIsData(data && data?.length > 0);
    }, [data]);

    return {
        enableBottomToolbar: isData,
        // enableFilters: isData,
        // enableColumnFilters: isData,
        enableDensityToggle: isData,
        enableFullScreenToggle: isData,
        enableRowActions: isActions && isData,
        enableColumnResizing: true,
        enableColumnVirtualization: true,
        // enableGlobalFilterModes: true,
        enablePagination: true,
        enablePinning: true,
        enableRowNumbers: false,
        enableRowVirtualization: true,
        // manualPagination: true,
        enableColumnPinning: true,
        isMultiSortEvent: () => true,
        manualFiltering: true,
        enableExpandAll: false,
        initialState: {
            columnPinning: {
                right: ["mrt-row-actions"],
            },
            density: "xs" as MRT_DensityState,
            showGlobalFilter: true,
        },
        mantinePaperProps: {
            shadow: 'none',
            ...(ComponentName !== 'Company Assigned Documents' ? { style: { border: 'none' } } : {})
        },
        mantineLoadingOverlayProps: {
            loaderProps: {
                color: clickableColor,
                type: loadertype,
                size: 'md',
            },
        },
        displayColumnDefOptions: {
            'mrt-row-expand': {
                Header: '',
                size: 50,
            },
        },
        mantineSearchTextInputProps: {
            variant: mantineSearchTextInputVariant,
        },
        mantineTableBodyRowProps: ({ row }: { row: MRT_Row<Tdata> }) => ({
            style: row.getIsExpanded() ? { borderTop: 'none', borderBottom: 'none' } : {},
        }),
        mantineTableBodyProps: {
            children: !isData ? (
                <Flex justify={'center'} mt={50}>
                    <NoDataFound title={ComponentName} dataType={`(${dataType})`} />
                </Flex>
            ) : undefined,
        },
    }
}

export const useMantineTableNewStyles = <Tdata extends MRT_RowData,>(
    data: Tdata[],
    ComponentName: string,
    isActions?: boolean,
    isExpandable?: boolean,
    isDataLoading?: boolean,
): Partial<MRT_TableOptions<Tdata>> => {

    const [isData, setIsData] = useState<boolean>(false);

    useEffect(() => {
        setIsData(data && data?.length > 0);
    }, [data]);

    return {
        enableColumnResizing: true,
        layoutMode: 'grid',
        enablePagination: true,
        enableFilters: true,
        enableBottomToolbar: true,
        manualPagination: true,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableSorting: true,
        enableEditing: false,
        enableFullScreenToggle: true,
        enableRowActions: isActions,
        enableExpandAll: isExpandable ? true : false,
        enableExpanding: isExpandable ? true : false,
        positionGlobalFilter: 'right',
        enableColumnFilters: true,
        enableColumnVirtualization: true,
        enableColumnPinning: true,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Actions',
                maxSize: 250,
                minSize: 50,
                size: 200,
            },
        },
        mantineTableProps: {
            highlightOnHover: true,
            withColumnBorders: false,
        },
        mantineTableBodyRowProps: {
            style: {
                transition: 'background-color 120ms ease',
                borderBottom: '1px solid #e5e7eb',
                position: 'relative',
                zIndex: 0,
                color: '#64748b !important',
                fontSize: '14px',
                fontWeight: 700,
            },
        },
        mantinePaperProps: {
            radius: 'xl',
            shadow: 'sm',
            p: '0px 0px',
            withBorder: false,
            style: {
                backgroundColor: '#ffffff',
                boxShadow:
                    '0 10px 30px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.05) !important',
            },
        },
        mantineTableHeadCellProps: {
            style: {
                fontSize: '10px',
                fontWeight: 600,
                color: '#94a3b8',
                letterSpacing: "2px",
                backgroundColor: 'transparent !important',
                borderRight: 'none !important',
                padding: '20px 20px',
                textTransform: 'uppercase',
                overflowWrap: 'break-word'
            },
        },
        mantineLoadingOverlayProps: {
            loaderProps: {
                color: clickableColor,
                type: loadertype,
                size: 'md',
            },
        },


        mantineTableBodyCellProps: ({ cell, table }) => ({
            style: {
                fontSize: table.getAllLeafColumns()[0].id === cell.column.id ? '12px' : 'inherit',
                fontWeight: table.getAllLeafColumns()[0].id === cell.column.id ? 900 : 'inherit',
                backgroundColor: '#fff !important',
                paddingTop: 20,
                paddingBottom: 20,
                paddingLeft: 20,
                paddingRight: 20,
                textTransform: 'capitalize',
                letterSpacing: 0.1,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                borderRight: 'none !important',
            },
        }),

        renderEmptyRowsFallback: () =>
            !isData && !isDataLoading ? (
                <TableNoDataFound
                    title={ComponentName}
                    contentWidth="100%"
                />
            ) : null,

        mantineTableContainerProps: {
            style: {
                borderRadius: 0,
                border: 'none'
            },
        },
        mantineTableHeadRowProps: {
            style: {
                borderBottom: '1px solid #e5e7eb',
                backgroundColor: 'rgb(248 250 252 / 0.5) !important',

            },
        },
        mantineBottomToolbarProps: {
            style: {
                zIndex: 0
            }
        },
        initialState: {
            columnPinning: {
                right: ["mrt-row-actions"],
            },
            density: "xs" as MRT_DensityState,
            showGlobalFilter: true,
        },
        mantineSearchTextInputProps: {
            variant: mantineSearchTextInputVariant,
        },
    }
};

const MONOSPACE_FONT = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

export const MRTcustomhourscomponent = ({
    value = 0,
    color = 'rgb(15 23 42)',
    fz = '0.875rem',
    trimDecimals = false,
    symbol = ''
}: {
    value?: number | string | null;
    color?: string;
    fz?: string | number;
    trimDecimals?: boolean;
    symbol?: string;
}) => {
    const parsed = Number(value ?? 0);
    const displayValue = Number.isNaN(parsed) ? '0' : trimDecimals ? (Number.isInteger(parsed) ? String(parsed) : parsed.toFixed(2).replace(/\.?0+$/, '')) : parsed.toFixed(2);
    return <Box ff={MONOSPACE_FONT} lts={'0.1em'} fz={fz} fw={700} lh={'1.24rem'} tt={'uppercase'} c={color}>{displayValue}{symbol}</Box>;
};
